import { Flex, Form, Radio } from 'antd';
import { QAPanelTemplate } from 'features/patient/assessment/assessment-controller/_components/questionnaire-qa-panel';
import { useState } from 'react';
import { PilotContent, PilotPageState } from './_components/pilot-content';
import { IntegrationImpactLayout } from './_components/layout';

/**
 * 2026-04-01 The Pilot consent screen is disabled to create an onboarding flow with less intermediary steps
 *            When a user signs into the app through the Pilot screen, they will be added into the Pilot
 * @returns
 */
export function PageIntegrationPilotConsent() {
  const [overrideState, setOverrideState] = useState<
    PilotPageState | undefined
  >();

  return (
    <IntegrationImpactLayout>
      <Flex gap={16} vertical>
        <QAPanelTemplate>
          <Form.Item label="State override">
            <Radio.Group
              value={overrideState}
              onChange={e => setOverrideState(e.target.value)}
              buttonStyle="solid"
              optionType="button"
              options={[
                { value: undefined, label: 'NO OVERRIDE' },
                { value: 'loading', label: 'OVERRIDE: Loading' },
                { value: 'in-pilot', label: 'OVERRIDE: In Pilot' },
                { value: 'not-in-pilot', label: 'OVERRIDE: Not in pilot' }
              ]}
            />
          </Form.Item>
        </QAPanelTemplate>
        <PilotContent overrideState={overrideState} />
      </Flex>
    </IntegrationImpactLayout>
  );
}
